import React, {Component} from 'react';
import './ErrorDialog.css';
import {Dialog} from '../widgets/';
import {connect} from 'react-redux';
import {uiActions} from '../chrome';

class ErrorDialog extends Component {
	render() {
		return (
			<Dialog
				onCancel={this.props.onCancel}
				onClose={this.props.onCancel}
				title={'Unexpected error'}
				buttons={['close']}>
				<div className="ErrorDialog" style={{textAlign: 'center', display: 'block'}}>
					<h1>
						<span className="icon icon-warning" /> Oops, a system error has occurred
					</h1>
					<p>
						Sorry about this! Our services could be having issues, or you may have uncovered a bug
						in our software.
					</p>
					<p>
						We would greatly appreciate it if you could let our{' '}
						<a href="https://b2me.zendesk.com">support team</a> know how it happened.
					</p>
				</div>
			</Dialog>
		);
	}
}

const ConnectedErrorDialog = connect(
	() => ({}),
	dispatch => ({
		onCancel: () => dispatch(uiActions.uiModal(null))
	})
)(ErrorDialog);

export default ConnectedErrorDialog;



// WEBPACK FOOTER //
// ./src/chrome/ErrorDialog.js